import React from "react";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useFeatures } from "flagged";

import MasterLayout from "@layouts/MasterLayout.react";
import { Div, Image, Button } from "@components/Generics.react";
import { settings } from "@config/settings/app.settings";
import RecommendedArticles from "@components/RecommendedArticles.react";
import TermsPage from "./panels/TermsPage.react";
import ReactPlayer from "react-player/lazy";
import { Divider } from "semantic-ui-react";

export default function DesktopHome(props) {
    const user = useSelector((state) => state.auth.user);
    const { t } = useTranslation("common");
    const features = useFeatures();
    const isPortrait = window.innerHeight > window.innerWidth;

    const stages = settings.gamification.stages;
    const userStage = settings.home[user.stage || stages.length];

    const pageContent =
        user.license.termsAccepted || !features.general.acceptTerms ? (
            <Div fullht fluid flex top-aligned>
                <Div wd="calc(100% - 360px)" padSides>
                    <Div fluid flex top-aligned>
                        <Div wd="40%" altText huge uppercase>
                            <Div wd="40%" altText huge uppercase txtCharcoal>
                                Welcome{" "}
                            </Div>
                            {user.branding?.name
                                ? "to " + user.branding?.name
                                : ""}
                        </Div>
                        <Div wd="60%">
                            <Div
                                rounded
                                noOverflow
                                gutter
                                className="video-responsive"
                            >
                                <ReactPlayer
                                    className="react-player"
                                    url={user.branding?.homeVideo}
                                    width="100%"
                                    height="100%"
                                />
                            </Div>
                        </Div>
                    </Div>
                    <Divider />
                    <br />
                    <Div ash basepad>
                        <Div altText large uppercase gutter>
                            How it works:
                        </Div>
                        <ul>
                            <li>
                                Watch the welcome video to understand the simulation journey and get started.
                            </li>
                            <li>
                                Follow your instructor's guidance and attempt simulations only on the assigned days.
                            </li>
                            <li>
                                Check each simulation card carefully for the corresponding Day and Act.
                            </li>
                            <li>
                                Click the appropriate simulation card to launch the assigned simulation.
                            </li>
                            <li>
                                Refer to the Infobase for all the information required to make decisions during the simulation.
                            </li>
                            <li>
                                Complete simulations in the prescribed sequence and avoid accessing future simulations before they are assigned.
                            </li>
                        </ul>
                        {/* this is only for axis simulation */}
                        {/* <Button
                            primary
                            href="/library"
                            content="Start Simulation"
                        /> */}
                    </Div>
                </Div>
                <Div wd="360px" fullht basepad peat rounded>
                    <Div gutter big uppercase altText>
                        {/* Quick Links: */}
                        {/* this is only for axis simulation */}
                        Infobase
                    </Div>
                    <Div
                        relative
                        fluid
                        style={{ height: "0", paddingBottom: "133%" }}
                    >
                        {userStage &&
                            _.map(userStage.images, ({ src, coords }, idx) => {
                                return (
                                    <NavLink
                                        to={t(`home.links.${src}`)}
                                        key={`homeelm-${idx}`}
                                    >
                                        <Image
                                            src={t(`home.images.${src}`)}
                                            style={{
                                                position: "absolute",
                                                left: `${coords[0]}%`,
                                                top: `${coords[1]}%`,
                                                width: `${coords[2]}%`,
                                            }}
                                        />
                                    </NavLink>
                                );
                            })}
                    </Div>
                </Div>
            </Div>
        ) : (
            <TermsPage />
        );
    const mobileView = (
            <Div centered fluid fullht balanced> 
                <Image
                    src={user.branding?.homeImage || "/assets/images/configurable/lock.png"}
                    fluid
                />
                <br />
                <Div altText massive gutter>Please Use a Desktop Device</Div>
                <Div altText large>
                    This website is optimized for larger screens and may not work correctly on mobile devices.
                    For the best experience, please view this site on a desktop or laptop computer.
                </Div>
            </Div>
    );
    // ========================= Render Function =================================
    return (
        <MasterLayout
            title={"Welcome"}
            mainPanel={!isPortrait ? pageContent : mobileView}
            rightPanelName={t(`components.recommended`)}
            rightPanel={<RecommendedArticles />}
            rootPage={true}
            hidePanelToggle
            startFullScreen={true}
        />
    );
}
